import type { ReactNode } from 'react'

import { PersonChooserProvider } from '@/shared/custom-fields'

import { UserPersonChooser } from './custom-fields/UserPersonChooser'
import { OrganizationReachProvider } from './organizations/OrganizationReachProvider'
import { CurrentSiteProvider } from './site/CurrentSiteProvider'
import { UserNamesProvider } from './users/UserNamesProvider'
import { UserReachProvider } from './users/UserReachProvider'

/**
 * Site Management's app-wide context: the current site, the `User` name lookup, which organizations
 * and people the caller may open, and the user chooser every person field opens.
 */
export function SiteManagementProvider(props: { readonly children: ReactNode }) {
  return (
    <CurrentSiteProvider>
      <UserNamesProvider>
        <OrganizationReachProvider>
          <UserReachProvider>
            <PersonChooserProvider chooser={UserPersonChooser}>{props.children}</PersonChooserProvider>
          </UserReachProvider>
        </OrganizationReachProvider>
      </UserNamesProvider>
    </CurrentSiteProvider>
  )
}
